import { BasicProps } from "components/types/BasicProps";
import { INft } from "logic/types/nft/INft";
import { FC } from "react";
import { UAccountNftCard } from "./UAccountNftCard";
import classNames from "classnames";
import { areTheSameNft } from "@unlockdfinance/verislabs-web3/utils";
import { MultipleSelectionBar } from "./MultipleSelectionBar";
import { useRouter } from "next/navigation";
import LoadingSpinner from "components/LoadingSpinner";
import { Filter, FilterOption } from "components/filter/Filter";
import { accountLiterals } from "../literals";

type Props = BasicProps & {
  multipleSelectionActive: boolean;
  nfts: INft[];
  isLoadingNfts: boolean;
  selectedNfts: INft[];
  onNftsWithdrawn: (nfts: INft[]) => void;
  onSelectedNft: (nft: INft) => void;
  filterOptions: FilterOption[];
  areNfts?: boolean;
};

const { noNftsDescriptionL1, noNftsDescriptionL2 } =
  accountLiterals.nftsSection;

export const NftsSection: FC<Props> = (props) => {
  const {
    nfts,
    className,
    multipleSelectionActive,
    onNftsWithdrawn,
    selectedNfts,
    isLoadingNfts,
    onSelectedNft,
    filterOptions,
    areNfts,
  } = props;
  const router = useRouter();

  const handleBorrowClick = () => {
    router.push(
      `/borrow/create-loan?${selectedNfts
        .map((nft) => `nft=${nft.nftId}`)
        .join("&")}`
    );
  };

  const handleNftWithdrawn = (nft: INft) => {
    onNftsWithdrawn([nft]);
  };

  return (
    <>
      <div
        className={classNames(
          "w-full flex gap-[15px] overflow-auto scrollbar p-0.5",
          className
        )}
      >
        {isLoadingNfts ? (
          <div className="w-full h-full flex justify-center items-center">
            <LoadingSpinner className="w-10 h-10" />
          </div>
        ) : nfts.length !== 0 || areNfts ? (
          <>
            <Filter className="w-[208px]" options={filterOptions} />

            <ul className="w-full flex flex-wrap gap-[15px]">
              {nfts.map((nft) => (
                <UAccountNftCard
                  key={nft.nftId}
                  nft={nft}
                  selectionActive={multipleSelectionActive}
                  onSelected={onSelectedNft}
                  isSelected={selectedNfts.some((_nft) =>
                    areTheSameNft(_nft, nft)
                  )}
                  onWithdrawn={handleNftWithdrawn}
                />
              ))}
            </ul>
          </>
        ) : (
          <div className="mt-[177px] w-full flex flex-col items-center gap-2.5">
            {/* <span className="text-2xl font-bold">{noNftsTitle}</span> */}
            <span className="w-[532px] text-center">
              {noNftsDescriptionL1}
              <br />
              {noNftsDescriptionL2}{" "}
              {/* <Link
                className="text-uyellow underline"
                href="https://docs.unlockd.finance"
                target="_blank"
              >
                {documentationDescriptions}
              </Link> */}
            </span>
          </div>
        )}
      </div>
      {multipleSelectionActive && (
        <MultipleSelectionBar
          nfts={selectedNfts}
          onBorrowClick={handleBorrowClick}
          onRemoveClick={onSelectedNft}
        />
      )}
    </>
  );
};
